module.exports = __webpack_public_path__ + "static/media/suisseintl-regular-webm.195b5cd9.woff";